import { createSlice } from '@reduxjs/toolkit';
import { NEW_THREAD, ARCHIVED_THREAD } from 'containers/chat/hooks/ChatContext';

const initialState = {
    conversations: {},
    messages: {},
    conversationList: [],
    currentConversationId: '',
    isArchivedThread: false,
    isDisplayArchivedThread: false,
    archivedThreadDate: new Date().toISOString(),
    isInitiateNewChat: false,
    isLinkClicked: false,
    conversationState: {},
};

const getConversationKey = (state, payload) => {
    return state.isDisplayArchivedThread ? ARCHIVED_THREAD : payload.key ? payload.key : NEW_THREAD;
};
const chatSlice = createSlice({
    name: 'chat',
    initialState,
    reducers: {
        resetChat: () => initialState,
        updateConversations: (state, action) => {
            const { payload } = action;
            state.conversations = {
                ...state.conversations,
                [getConversationKey(state, payload)]: payload.value,
            };
        },
        updateConversationState: (state, action) => {
            const { payload } = action;
            const key = getConversationKey(state, payload);
            state.conversationState = {
                ...state.conversationState,
                [key]: state.conversationState[key]
                    ? { ...state.conversationState[key], ...payload.value }
                    : payload.value,
            };
        },
        updateMessages: (state, action) => {
            const { payload } = action;
            if (payload?.extraData?.isRemoveNew && state?.messages?.[NEW_THREAD]) {
                delete state?.messages?.[NEW_THREAD];
            }
            state.messages = {
                ...state.messages,
                [getConversationKey(state, payload)]: payload.value,
            };
        },
        updateConversationList: (state, action) => {
            const { payload } = action;
            state.conversationList = payload.value;
        },
        updateCurrentConversationId: (state, action) => {
            const { payload } = action;
            state.currentConversationId = payload.value;
        },
        updateIsArchivedThread: (state, action) => {
            const { payload } = action;
            state.isArchivedThread = payload.value;
        },
        updateIsDisplayArchivedThread: (state, action) => {
            const { payload } = action;
            state.isDisplayArchivedThread = payload.value;
        },
        updateArchivedThreadDate: (state, action) => {
            const { payload } = action;
            state.archivedThreadDate = payload.value;
        },
        updateIsInitiateNewChat: (state, action) => {
            const { payload } = action;
            state.isInitiateNewChat = payload.value;
        },
        updateIsLinkClicked: (state, action) => {
            const { payload } = action;
            state.isLinkClicked = payload;
        },
        removeConversationState: (state, action) => {
            const { payload } = action;
            if (state.conversationState[payload.key]) {
                delete state.conversationState[payload.key];
            }
        },
        removeReduxConversation: (state, action) => {
            const { payload } = action;
            if (state.conversations[payload.key]) {
                delete state.conversations[payload.key];
            }
        },
        removeReduxMessage: (state, action) => {
            const { payload } = action;
            if (state.messages[payload.key]) {
                delete state.messages[payload.key];
            }
        },
    },
});

export const {
    resetChat,
    updateConversations,
    updateMessages,
    updateConversationList,
    updateCurrentConversationId,
    updateIsArchivedThread,
    updateIsDisplayArchivedThread,
    updateArchivedThreadDate,
    updateIsInitiateNewChat,
    updateConversationState,
    removeConversationState,
    removeReduxConversation,
    removeReduxMessage,
    updateIsLinkClicked,
} = chatSlice.actions;
const chatReducer = chatSlice.reducer;
export default chatReducer;
